import React from "react";
import { Alert, Container, AlertTitle } from "@mui/material";
import ModalContainer from "../modal-container";
import StyledAlert from "./style";

const getTitle = (severity) => {
  switch (severity) {
    case "error":
      return "Error";

    case "warning":
      return "Warning";

    case "success":
      return "Success";

    case "info":
      return "Info";

    default:
      return null;
  }
};

const CustomAlert = ({ title, message = "", onClose, severity = "info" }) => {
  const finalTitle = title || getTitle(severity);

  return (
    <ModalContainer>
      <StyledAlert>
        <Container maxWidth="md" style={{ height: "100%", marginBottom: 30 }}>
          <div className="alert-container">
            <div className="alert">
              <div className="alert-background" />
              <Alert
                severity={severity}
                onClose={onClose}
                slotProps={{ closeButton: { variant: "text" } }}
              >
                {finalTitle && <AlertTitle>{finalTitle}</AlertTitle>}
                {message}
              </Alert>
            </div>
          </div>
        </Container>
      </StyledAlert>
    </ModalContainer>
  );
};

export default CustomAlert;
